<template>
    <main class="thankyou">
        <div class="container">
            <Header title="Actualiza tu clave" />
            <CardMessage title="¡Muchas gracias!" />
            <p class="my-6 is-size-7">
                ¿Ya posees una cuenta?
                <a
                    class="ml-2 has-text-weight-semibold"
                    v-on:click.prevent="$router.push('/')"
                >
                    Ingresa aquí
                </a>
            </p>
        </div>
    </main>
</template>

<script>
import Header from "@/components/signupAndLogin/Header";
import CardMessage from "@/components/signupAndLogin/CardMessage";

export default {
    name: "Thankyou",
    components: {
        Header,
        CardMessage,
    },
};
</script>
